import { Link, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  setRunningData,
  addSelectedData,
} from "../../../AsianExchangeSrc/redux/slices/fullmarketSlice";
import LinkEventBox from "./LinkEventBox";
import { format, addDays } from "date-fns";

const InPlayCard = () => {
  const dispatch = useDispatch();

  const [searchParams] = useSearchParams();

  const category = searchParams.get("category");

  const today = new Date();
  const formattedToday = format(today, "yyyy-MM-dd");
  const tomorrow = addDays(today, 1);
  const formattedTomorrow = format(tomorrow, "yyyy-MM-dd");

  const filterMatchesByDate = (matches, dateToCheck) => {
    return matches?.data
      ?.filter(
        (e) =>
          e?.openDate &&
          format(new Date(e?.openDate), "yyyy-MM-dd") === dateToCheck
      )
      .map((e) => e);
  };

  const { matches: cricketMatches } = useSelector(
    (state) => state.matches.cricket
  );
  const { matches: soccerMatches } = useSelector(
    (state) => state.matches.soccer
  );
  const { matches: tennisMatches } = useSelector(
    (state) => state.matches.tennis
  );

  const filteredCricketMatchesToday = filterMatchesByDate(
    cricketMatches,
    formattedToday
  );
  const filteredCricketMatchesTomorrow = filterMatchesByDate(
    cricketMatches,
    formattedTomorrow
  );

  const filteredSoccerMatchesToday = filterMatchesByDate(
    soccerMatches,
    formattedToday
  );
  const filteredSoccerMatchesTomorrow = filterMatchesByDate(
    soccerMatches,
    formattedTomorrow
  );

  const filteredTennisMatchesToday = filterMatchesByDate(
    tennisMatches,
    formattedToday
  );
  const filteredTennisMatchesTomorrow = filterMatchesByDate(
    tennisMatches,
    formattedTomorrow
  );

  const handleDataClick = (teamName, odds, type) => {
    const newData = { teamName, odds, oddsType: type };

    dispatch(addSelectedData(newData));
  };

  const toggleDropdown = (id) => {
    document.getElementById(`sub-${id}`).classList.toggle("onsub");
  };

  const handleMarket = (runningData) => {
    dispatch(setRunningData(runningData));
  };

  return (
    <>
      <>
        <ul className="dropdownul">
          <li onClick={() => toggleDropdown("cricket")}>Cricket</li>
          <div className="subdropdown" id="sub-cricket">
            <div className="slip-head">
              <div className="slip-head-one">
                <p>Matched</p>
              </div>
              <div className="slip-head-two">
                <div className="slip-head-two-item">1</div>
                <div className="slip-head-two-item">x</div>
                <div className="slip-head-two-item">2</div>
                <div className="item-book"></div>
              </div>
            </div>

            {(() => {
              const data =
                category === "today"
                  ? filteredCricketMatchesToday
                  : category === "tomorrow"
                  ? filteredCricketMatchesTomorrow
                  : cricketMatches?.data;

              const filtered = data?.filter((e) =>
                category !== "today" && category !== "tomorrow"
                  ? e?.matchOdds?.some((odds) => odds?.inplay)
                  : true
              );

              if (!filtered || filtered.length === 0) {
                return (
                  <div className="text-black text-[13px] text-center py-2">
                    No live data in cricket
                  </div>
                );
              }

              return filtered.map((e, i) => {
                const filteredOdds = e?.matchOdds?.find(
                  (odds) => odds?.marketId === e?.marketId
                );
                return (
                  <div className="innerlink2" key={i}>
                    <div className="linkbox">
                      <div className="innerlink">
                        <Link
                          to={`/fullMarket?eventType=4&eventId=${e?.eventId}&marketId=${e?.marketId}&joinedMarketIds=${e?.joinedMarketIds}&competitionId=${e?.competitionId}&bm=${e?.bm}&fancy=${e?.fancy}&pc=${e?.pc}&eventName=${e.eventName}`}
                          onClick={() => handleMarket(e?.matchRunners)}
                        >
                          <div
                            className={`rounded-full h-2 w-2 border-[0.5] border-black ${
                              e?.matchOdds?.some((odds) => odds?.inplay)
                                ? "bg-[#6bbd0f]"
                                : "bg-[#c5d0d8]"
                            }`}
                          />
                          {e?.eventName}
                        </Link>
                        {e?.matchOdds?.some((odds) => odds?.inplay) && (
                          <p>
                            <span>In-Play</span>{" "}
                            <div className="play-btn"></div>
                          </p>
                        )}
                      </div>
                      <div className="Matched-details">
                        <p>PTE---</p>
                      </div>
                    </div>
                    <LinkEventBox
                      eventName={e?.eventName}
                      filteredOdds={filteredOdds}
                      handleDataClick={handleDataClick}
                      eventId={i}
                    />
                  </div>
                );
              });
            })()}
          </div>
        </ul>

        <ul className="dropdownul">
          <li onClick={() => toggleDropdown("soccer")}>Soccer</li>
          <div className="subdropdown" id="sub-soccer">
            <div className="slip-head">
              <div className="slip-head-one">
                <p>Matched</p>
              </div>
              <div className="slip-head-two">
                <div className="slip-head-two-item">1</div>
                <div className="slip-head-two-item">x</div>
                <div className="slip-head-two-item">2</div>
                <div className="item-book"></div>
              </div>
            </div>

            {(() => {
              const data =
                category === "today"
                  ? filteredSoccerMatchesToday
                  : category === "tomorrow"
                  ? filteredSoccerMatchesTomorrow
                  : soccerMatches?.data;

              const filtered = data?.filter((e) =>
                category !== "today" && category !== "tomorrow"
                  ? e?.matchOdds?.some((odds) => odds?.inplay)
                  : true
              );

              if (!filtered || filtered.length === 0) {
                return (
                  <div className="text-black text-[13px] text-center py-2">
                    No live data in soccer
                  </div>
                );
              }

              return filtered.map((e, i) => {
                const filteredOdds = e?.matchOdds?.find(
                  (odds) => odds?.marketId === e?.marketId
                );
                return (
                  <div className="innerlink2" key={i}>
                    <div className="linkbox">
                      <div className="innerlink">
                        <Link
                          to={`/fullMarket?eventType=1&eventId=${e?.eventId}&joinedMarketIds=${e?.joinedMarketIds}&marketId=${e?.marketId}&competitionId=${e?.competitionId}&bm=${e?.bm}&fancy=${e?.fancy}&pc=${e?.pc}&eventName=${e.eventName}`}
                          onClick={() => handleMarket(e?.matchRunners)}
                        >
                          <div
                            className={`rounded-full h-2 w-2 border-[0.5] border-black ${
                              e?.matchOdds?.some((odds) => odds?.inplay)
                                ? "bg-[#6bbd0f]"
                                : "bg-[#c5d0d8]"
                            }`}
                          />
                          {e?.eventName}
                        </Link>
                        {e?.matchOdds?.some((odds) => odds?.inplay) && (
                          <p>
                            <span>In-Play</span>{" "}
                            <div className="play-btn"></div>
                          </p>
                        )}
                      </div>
                      <div className="Matched-details">
                        <p>PTE---</p>
                      </div>
                    </div>
                    <LinkEventBox
                      eventName={e?.eventName}
                      filteredOdds={filteredOdds}
                      handleDataClick={handleDataClick}
                      eventId={i}
                    />
                  </div>
                );
              });
            })()}
          </div>
        </ul>

        <ul className="dropdownul">
          <li onClick={() => toggleDropdown("tennis")}>Tennis</li>
          <div className="subdropdown" id="sub-tennis">
            <div className="slip-head">
              <div className="slip-head-one">
                <p>Matched</p>
              </div>
              <div className="slip-head-two">
                <div className="slip-head-two-item">1</div>
                <div className="slip-head-two-item">x</div>
                <div className="slip-head-two-item">2</div>
                <div className="item-book"></div>
              </div>
            </div>

            {(() => {
              const data =
                category === "today"
                  ? filteredTennisMatchesToday
                  : category === "tomorrow"
                  ? filteredTennisMatchesTomorrow
                  : tennisMatches?.data;

              const filtered = data?.filter((e) =>
                category !== "today" && category !== "tomorrow"
                  ? e?.matchOdds?.some((odds) => odds?.inplay)
                  : true
              );

              if (!filtered || filtered.length === 0) {
                return (
                  <div className="text-black text-[13px] text-center py-2">
                    No live data in tennis
                  </div>
                );
              }

              return filtered.map((e, i) => {
                const filteredOdds = e?.matchOdds?.find(
                  (odds) => odds?.marketId === e?.marketId
                );
                return (
                  <div className="innerlink2" key={i}>
                    <div className="linkbox">
                      <div className="innerlink">
                        <Link
                          to={`/fullMarket?eventType=2&eventId=${e?.eventId}&joinedMarketIds=${e?.joinedMarketIds}&marketId=${e?.marketId}&competitionId=${e?.competitionId}&bm=${e?.bm}&fancy=${e?.fancy}&pc=${e?.pc}&eventName=${e.eventName}`}
                          onClick={() => handleMarket(e?.matchRunners)}
                        >
                          <div
                            className={`rounded-full h-2 w-2 border-[0.5] border-black ${
                              e?.matchOdds?.some((odds) => odds?.inplay)
                                ? "bg-[#6bbd0f]"
                                : "bg-[#c5d0d8]"
                            }`}
                          />
                          {e?.eventName}
                        </Link>
                        {e?.matchOdds?.some((odds) => odds?.inplay) && (
                          <p>
                            <span>In-Play</span>{" "}
                            <div className="play-btn"></div>
                          </p>
                        )}
                      </div>
                      <div className="Matched-details">
                        <p>PTE---</p>
                      </div>
                    </div>
                    <LinkEventBox
                      eventName={e?.eventName}
                      filteredOdds={filteredOdds}
                      handleDataClick={handleDataClick}
                      eventId={i}
                    />
                  </div>
                );
              });
            })()}
          </div>
        </ul>
      </>
    </>
  );
};

export default InPlayCard;
